import { makeEntityScaffold } from '@classpass/saga-tools';
import urls from 'constants/urls';
import { transformKeysToCamelCase } from '../../../helpers/core';

const handler = ({ httpClient }, venueId, pageNumber, perPage) => {
  const endpoint = urls.reports.payouts({ venue_id: venueId, page: pageNumber, per_page: perPage });
  return httpClient.get(endpoint).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.PAYOUT_REPORTS', handler, {
  defaultKey: (_, venueId) => `${venueId}`,
});
